// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__-Y7br","title":"ClientReferral_title__2O3WU","itemText":"ClientReferral_itemText__29GZN"};